export type Uuid = string;
export type FirestoreId = string;
export type StripeId = string;

export const GLOBAL_FALLBACK_UUID = "00000000-0000-0000-0000-000000000000" as const;
